import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-microInverter",
  "use": "dv-microInverter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dv-microInverter\"><defs><style>#dv-microInverter .cls-1{fill:#fff1de;fill-opacity:0}</style></defs><title>资源 19</title><g id=\"dv-microInverter_图层_2\" data-name=\"图层 2\"><g id=\"dv-microInverter_图层_1-2\" data-name=\"图层 1\"><path id=\"dv-microInverter_矩形_265\" data-name=\"矩形 265\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path d=\"M24 10.77V9.69h-1.72V5.22a1.69 1.69 0 0 0-1.69-1.69H3.41a1.7 1.7 0 0 0-1.7 1.69v8.94H0v1.08h1.71v1.07H0v1.08h1.71v1.39a1.7 1.7 0 0 0 1.7 1.69h17.18a1.69 1.69 0 0 0 1.69-1.7v-5.85H24v-1.07h-1.72v-1.08zM13.26 14.7h-1v-3.6l-.18.53-.93 2.54h-.65l-.93-2.54-.2-.56c0 .33.05.67.05.94v2.69h-.85V9.3h1.1l1 2.69c.07.2.13.39.19.57a2.58 2.58 0 0 0 .08.26 1.09 1.09 0 0 1 .05-.17v-.13c.05-.17.11-.35.17-.52l.59-1.67.36-1h1.12zm2.17 0h-1V9.3h1z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-microInverter.svg
// module id = 9PNy
// module chunks = 6